export const INSPECTIONKEYS = {
  D: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "inspection_date",
        header: {
          text: "Date",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ],
    data   : "drafts",
    route  : "open_inspections_list",
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'inspection_date'
    }
  },
  RA: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_sent_on",
        header: {
          text: "Date Requested",
        },
        pipe    : "globalDate",
        pipeArgs: 'mediumDate'
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "customer_viewed",
        header: {
          text: "Viewed On",
        },
        pipe    : "globalDate",
        pipeArgs: "MMM d, yyyy h:mm a"
      }
    ],
    data   : "requested",
    route  : "requested_inspections_list",
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'request_sent_on'
    }
  },
  A: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "Date Approved",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ],
    data   : "approved",
    route  : "approved_inspections_list",
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'request_closed_on'
    }
  },
  R: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "Date Refused",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ],
    data   : "refused",
    route  : "refused_inspections_list",
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'request_closed_on'
    }
  },
  F: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "UK Finalized Translation",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ],
    data   : "finalized",
    route  : "finalized_inspections_list",
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'inspectirequest_closed_onon_date'
    }
  },
  // Note: not an actual status.
  FW: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "Date Finalized",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ],
    data   : "finalized_work",
    route  : "inspections_turned_work_list",
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'request_closed_on'
    }
  },
};
